import React from 'react';
import { FormattedMessage } from 'react-intl';
import MuiStepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const Stepper = ({ steps, activeStep }) => {
  return (
    <MuiStepper activeStep={activeStep}>
      {steps.map(step => (
        <Step key={`step/${step.number}`}>
          <StepLabel>
            <FormattedMessage id={step.label} />
          </StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};

export default Stepper;
